export default "__VITE_ASSET__5aSRGuKQ__"